const amplify_config = {
  region: 'ap-southeast-1',
  // OPTIONAL - Amazon Cognito User Pool ID
  userPoolId: 'ap-southeast-1_rtVMHvdWO',

  // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
  userPoolWebClientId: 'a7lr3dp74g149i2gdj8r36lci',

  // OPTIONAL - Hosted UI configuration
  oauth: {
    domain: 'crm-dashboard-prod.auth.ap-southeast-1.amazoncognito.com',
    scope: ['email', 'profile', 'openid'],
    redirectSignIn: 'https://lifeline.blinkit.com/',
    redirectSignOut: 'https://lifeline.blinkit.com/',
    responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
  },
};

const auth_urls = {
  fetch_user_info: 'https://lifeline.blinkit.com/api/user_info/',
};

export { amplify_config, auth_urls };
